<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <defs>
      <path id="a" d="M0 0h81.914v100H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        :fill="iconColor"
        d="M43.144 69.434c.417-.592.626-1.515.626-2.77 0-1.258-.212-2.19-.635-2.79-.423-.6-1.053-.901-1.892-.901-1.71 0-2.563 1.23-2.563 3.692 0 2.439.848 3.658 2.545 3.658.862 0 1.502-.296 1.919-.89M13.398 63.974c-.181-.73-.3-1.254-.358-1.57a36.34 36.34 0 0 1-.306 1.449c-.152.673-.49 1.998-1.014 3.976h2.683l-.543-2.07a72.784 72.784 0 0 1-.462-1.785"
      />
      <g>
        <path
          :fill="iconColor"
          d="M58.607 66.078v-5.702h3.037v12.612h-4.469l-4.607-8.886h-.077c.11 1.398.164 2.465.164 3.201v5.685h-3.02V60.376h4.451l4.59 8.765h.052a50.417 50.417 0 0 1-.12-3.063zm-23.517.57c0-2.099.525-3.703 1.575-4.81 1.05-1.107 2.575-1.66 4.577-1.66 2.007 0 3.527.548 4.562 1.647 1.036 1.1 1.554 2.712 1.554 4.84 0 2.122-.522 3.735-1.562 4.84-1.04 1.103-2.565 1.656-4.572 1.656-1.979 0-3.495-.556-4.55-1.665-1.056-1.11-1.584-2.727-1.584-4.849zm-5.297-.57v-5.702h3.037v12.612h-4.469l-4.607-8.886h-.077c.11 1.398.163 2.465.163 3.201v5.685h-3.019V60.376h4.452l4.59 8.765h.051a50.417 50.417 0 0 1-.12-3.063zm41.414 27.403H16.07c-2.286 0-4.148-1.849-4.148-4.124v-4.77h51.401c2.384 0 4.316-1.918 4.316-4.288V54.29c0-2.37-1.932-4.289-4.316-4.289h-51.4V10.643c0-2.269 1.861-4.119 4.147-4.119l37.958-.039V20.43c0 4.073 3.324 7.38 7.426 7.38l13.743-.039.155 61.586c0 2.275-1.857 4.124-4.144 4.124zM10.374 72.988H6.63l4.115-12.664h4.547l4.166 12.664h-3.726l-.622-2.363h-4.098l-.638 2.363zM56.48 0H16.07C10.165 0 5.36 4.78 5.36 10.643V50H4.315C1.932 50 0 51.92 0 54.288V80.3c0 2.37 1.932 4.287 4.315 4.287H5.36v4.77c0 5.87 4.805 10.642 10.708 10.643H71.21c5.9 0 10.705-4.774 10.705-10.643V25.19L56.48 0z"
        />
      </g>
      <path
        :fill="iconColor"
        d="M29.877 36.58c0-.927.27-1.643.809-2.147.539-.504 1.334-.756 2.382-.756 1.008 0 1.782.255 2.322.764.539.509.809 1.223.809 2.14s-.28 1.628-.84 2.132c-.559.504-1.323.756-2.291.756-.998 0-1.779-.25-2.344-.748-.565-.5-.847-1.212-.847-2.14zm.65-5.292v-1.301c0-.988.202-1.823.605-2.503.403-.68 1.12-1.343 2.148-1.988.816-.515 1.404-.978 1.762-1.392.357-.413.537-.887.537-1.421 0-.424-.192-.76-.575-1.006-.383-.247-.882-.371-1.497-.371-1.523 0-3.302.54-5.339 1.618l-2.102-4.113c2.51-1.432 5.132-2.147 7.864-2.147 2.248 0 4.013.494 5.293 1.48 1.28.99 1.922 2.335 1.922 4.04 0 1.219-.286 2.275-.855 3.168-.57.892-1.48 1.736-2.73 2.533-1.059.686-1.722 1.187-1.989 1.505a1.695 1.695 0 0 0-.401 1.127v.77h-4.643z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-anon',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
